export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    padding: `20px 30px 0px`
  },
  resendMail: {
    display: 'flex',
    flexShrink: 0
  }
};
